import { BookImage, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { getAuthorNames } from '@fable/utils'
import { ReviewPill } from 'components/review_pill'
import altTag from 'utils/altTag'
import { BookDetailButtonsV2 } from './v2'
import { BookDetailButtons } from './BookDetailButtons'

interface Props {
  hasClubs?: boolean
  isTestActive?: boolean
  mini?: boolean
  book: Book
}

export const BookDetailHeader = ({
  hasClubs = false,
  isTestActive = false,
  mini = false,
  book,
}: Props) => {
  const { colors } = useTheme()

  const getButtons = () => {
    if (mini) return null
    if (isTestActive) return <BookDetailButtonsV2 book={book} />
    return <BookDetailButtons book={book} hasClubs={hasClubs} />
  }

  return (
    <div id="book-group" data-isbn={book.isbn}>
      <ReviewPill
        className={css`
          display: inline-flex;
        `}
        rating={book?.review_average}
        count={book?.review_count || 0}
        inverted
        hideCount
        hidden
      />
      <Text
        id="book-title"
        className={css`
          margin: 8px 0 4px;
        `}
        type="header"
        sizing="M"
        color={colors.uiGraphite}
      >
        {book?.title}
      </Text>
      <Text
        type="body"
        sizing="M"
        color={`${colors.uiGraphite}cc`}
        truncate={2}
      >
        By <span id="book-author">{getAuthorNames(book?.authors)}</span>
      </Text>
      <BookImage
        className={css`
          margin: 32px auto;
          width: 190px;
          height: 287px;
          border-radius: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        `}
        image={book?.cover_image || ''}
        altTag={altTag?.storeBook({
          title: book?.title,
          authors: book?.authors,
        } as Book)}
      />
      {getButtons()}
    </div>
  )
}
